import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import Sidebar from "@/components/Sidebar";
import { toast } from "sonner";
import { Copy, Trash2, FileDown, Plus, Search, Eye } from "lucide-react";

export default function Quotations() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  const load = async (query = "") => {
    const { data } = await api.get("/quotations", { params: { q: query } });
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const dupe = async (id) => {
    const { data } = await api.post(`/quotations/${id}/duplicate`);
    toast.success("Duplicated");
    load(q);
  };
  const del = async (id) => {
    if (!confirm("Delete this quotation?")) return;
    await api.delete(`/quotations/${id}`);
    toast.success("Deleted");
    load(q);
  };

  return (
    <div className="flex min-h-screen">
      <Sidebar role="agent" />
      <main className="flex-1 bg-[#FCFCFC] p-8 lg:p-12">
        <div className="max-w-6xl">
          <div className="flex items-start justify-between">
            <div>
              <div className="overline">Archive</div>
              <h1 className="font-editorial text-4xl mt-2">All quotations</h1>
            </div>
            <Link to="/quotations/new" data-testid="quotations-new-btn" className="btn-bronze inline-flex items-center gap-2">
              <Plus size={15} /> New Quotation
            </Link>
          </div>

          <div className="mt-6 flex items-center gap-3">
            <div className="relative flex-1 max-w-md">
              <Search size={14} className="absolute left-3 top-3 text-slate-400" />
              <input
                data-testid="quotations-search"
                value={q}
                onChange={(e)=>setQ(e.target.value)}
                onKeyDown={(e)=>{ if (e.key === "Enter") load(q); }}
                placeholder="Search by number, lead, destination…"
                className="w-full pl-9 pr-3 py-2.5 border border-border rounded text-sm bg-white"
              />
            </div>
            <button data-testid="quotations-search-btn" onClick={()=>load(q)} className="text-xs uppercase tracking-widest px-4 py-2 border border-border rounded hover:border-[#16A34A]">Filter</button>
          </div>

          <div className="mt-6 bg-white border border-border rounded">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
                <tr>
                  <th className="text-left px-6 py-3">Number</th>
                  <th className="text-left px-6 py-3">Title</th>
                  <th className="text-left px-6 py-3">Destination</th>
                  <th className="text-left px-6 py-3">Lead</th>
                  <th className="text-left px-6 py-3">Dates</th>
                  <th className="text-left px-6 py-3">Status</th>
                  <th className="px-6 py-3"></th>
                </tr>
              </thead>
              <tbody>
                {items.length === 0 && (
                  <tr><td colSpan={7} className="text-center py-12 text-slate-400 text-sm">No quotations yet.</td></tr>
                )}
                {items.map((it) => (
                  <tr key={it.id} className="border-t border-border hover:bg-slate-50">
                    <td className="px-6 py-3 font-mono-e text-xs">{it.quotation_number}</td>
                    <td className="px-6 py-3">{it.package_title || "—"}</td>
                    <td className="px-6 py-3">{it.destination?.country || "—"}</td>
                    <td className="px-6 py-3">{it.lead?.name || "—"}</td>
                    <td className="px-6 py-3 text-xs text-slate-500">{it.start_date || "—"} → {it.end_date || "—"}</td>
                    <td className="px-6 py-3"><span className={`text-xs px-2 py-0.5 rounded ${it.status === "draft" ? "bg-amber-50 text-amber-700 border border-amber-200" : "bg-emerald-50 text-emerald-700 border border-emerald-200"}`}>{it.status}</span></td>
                    <td className="px-6 py-3">
                      <div className="flex items-center justify-end gap-2">
                        <Link to={`/quotations/${it.id}/preview`} data-testid={`quote-view-${it.id}`} className="p-2 hover:text-[#16A34A]"><Eye size={14} /></Link>
                        <Link to={`/quotations/${it.id}/edit`} data-testid={`quote-edit-${it.id}`} className="text-xs uppercase tracking-widest text-[#16A34A] px-2">Edit</Link>
                        <button data-testid={`quote-dup-${it.id}`} onClick={()=>dupe(it.id)} className="p-2 hover:text-[#16A34A]"><Copy size={14} /></button>
                        <button data-testid={`quote-del-${it.id}`} onClick={()=>del(it.id)} className="p-2 hover:text-red-600"><Trash2 size={14} /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
}
